<script lang="ts">
  import FluidPostCard from "$lib/molecules/newsroom/cards/FluidPostCard.svelte";
  import type { NewsroomListStoryblok } from "$types/components";
    import type { PostsResponse } from "$types/data";

  export let blok: NewsroomListStoryblok;
  export let posts: PostsResponse["data"]["stories"];

  const maxColumns = blok.maxColumns ? Number(blok.maxColumns) : 4;
</script>

<div
  class="fluid-grid grid gap-[24px]"
  class:sm:grid-cols-1={maxColumns >= 2}
  class:md:grid-cols-3={maxColumns >= 3}
  class:xl:grid-cols-4={maxColumns >= 4}
>
  {#if posts}
    {#each posts as post}
      <FluidPostCard {blok} {post} />
    {/each}
  {/if}
</div>

<style>
  .fluid-grid {
    container: fluidGrid / inline-size;
  }
</style>
